@if (headerWidgets?.length) {
    <ms-widget-slot
        class="composable-header-slot"
        [page]="accessorService.getPage()"
        [layoutTemplate]="accessorService.getLayoutTemplate()"
        [parent]="composableWidget"
        [widget]="headerWidgets" />
}
@if (!parent) {
    @if (!singleItemMode && tabsVM?.length) {
        <ms-tab-group-counter indicator="underline" size="small" [tabs]="tabsVM!" (tabSelected)="composableNavigationSelected($event.name)" />
    }
    @if (singleItemMode && title) {
        <div class="composable-header" [ngClass]="{ 'clickable-widget-header': !!headerChevronLink }" (click)="headerNavigationHandler()">
            <ng-container *msShowInEpcot="true">
                @if (activeItemCompetition && activeItemCompetition.sportId && activeItemCompetition.id) {
                    <ms-competition-logo [sportId]="activeItemCompetition.sportId" [leagueId]="activeItemCompetition.id" />
                }
            </ng-container>
            <div class="composable-title" [style.padding-right]="headerChevronLink ? 0 : undefined" [innerHTML]="title | msTrust: 'html'"></div>
            @if (headerChevronLink) {
                <vn-icon class="header-navigation-chevron" name="theme-right" size="14" />
            }
        </div>
    }
    @if (childNavigation && childNavigation.length > 1 && !hideSecondlevelNavigation) {
        @if (singleItemMode && showPrimaryNavAsTab) {
            <ms-widget-tab-bar [tabs]="childNavigation" (select)="childNavigationSelected($event)" />
        } @else {
            <ms-widget-pill [pills]="childNavigation" (select)="childNavigationSelected($event)" />
        }
    }
}

@if (widgets?.length) {
    @if (!isAllTabActive) {
        <ms-widget-slot
            [page]="accessorService.getPage()"
            [layoutTemplate]="accessorService.getLayoutTemplate()"
            [parent]="composableWidget"
            [widget]="widgets"
            [attr.data-menu-item-id]="getActiveId" />
    } @else {
        <ms-composable-accordions
            [widgets]="widgets"
            [navigation]="childNavigation.length === 1 ? childNavigation : childNavigation.slice(1)"
            [isShowMoreEnabled]="allTabSettings.isShowMoreEnabled"
            [maxEventsPerAccordion]="allTabSettings.maxEventsPerAccordion"
            (trackLinkClick)="trackLinkClick($event)"
            (trackAccordionClick)="trackAccordionClick($event)" />
    }
} @else {
    <ms-error severity="info" [message]="translations.ComposableEmptyTab ?? ''" [links]="false" />
}
